module.exports = __webpack_public_path__ + "img/profile.ae280cb2.svg";